import { WorkOrderAssetsTabEffects } from "../features/work-order-assets-tab/store/work-order-assets-tab.effects";
import { WorkOrderProductsEffects } from "../features/work-order-products/store/work-order-products.effects";

export const WorkOrderEffects = [...WorkOrderAssetsTabEffects, ...WorkOrderProductsEffects];
